import { createEntityAdapter, EntityState, EntityAdapter } from '@ngrx/entity';

import { Site } from '../../sites.model';

import * as siteActions from '../actions/sites.actions';
import { ActionType } from '../actions/sites.actions';


export interface State extends EntityState<Site> { fetchRunning: null; addSiteStatus: { status: null, id: null }; }

export const siteAdapter: EntityAdapter<Site> = createEntityAdapter<Site>();

export const initialState: State = siteAdapter.getInitialState({ fetchRunning: null, addSiteStatus: { status: null, id: null } });


export function siteReducer(
  state: State = initialState,
  action: siteActions.SiteActions
): any {
  switch (action.type) {

    case ActionType.FETCH_SITES_BY_COMPANYIDSITEID_SUCCESS:
      return siteAdapter.setAll(action.sites, {
        ...state,
        fetchRunning: false,
      });

    case ActionType.FETCH_SITES_BY_COMPANYID_SUCCESS:
      return siteAdapter.setAll(action.sites, {
        ...state,
        fetchRunning: false,
      });

    case ActionType.FETCH_SITES_SUCCESS:
      return siteAdapter.setAll(action.sites, {
        ...state,
        fetchRunning: false,
      });

    case ActionType.ADD_SITE:
      return {
        ...state,
        fetchRunning: true,
        addSiteStatus: { status: false, id: null }
      };
    case ActionType.ADD_SITE_SUCCESS:
      return siteAdapter.addOne(action.site, {
        ...state,
        fetchRunning: false,
        addSiteStatus: { status: true, id: action.site.id }
      });

    case ActionType.ADD_SITE_FAILED:
      return {
        ...state,
        fetchRunning: false,
        addSiteStatus: { status: false, id: null }
      };

    case ActionType.DELETE_SITE:
      return {
        ...state,
        fetchRunning: true,
      };
    // case ActionType.DELETE_SITE_SUCCESS:
    //   return siteAdapter.removeOne(action.id, {
    //     ...state,
    //     fetchRunning: false,
    //   });

    case ActionType.DELETE_SITE_FAILED:
      return {
        ...state,
        fetchRunning: false,
      };
    case ActionType.UPDATE_SITE:
      return {
        ...state,
        fetchRunning: true,
      };

    case ActionType.UPDATE_SITE_SUCCESS:
      return siteAdapter.updateOne({ id: action.id, changes: action.changes, }, {
        ...state,
        fetchRunning: false,
      });



    case ActionType.UPDATE_SITE_FAILED:
      return {
        ...state,
        fetchRunning: false,
      };



    //  return siteAdapter.addOne(action.payload.site, state);
    // case siteActions.TOGGLE_DONE:
    //   return siteAdapter.updateOne(
    //     { id: action.payload.id, changes: { done: action.payload.done } },
    //     state
    //   );
    // case siteActions.UPDATE_SITE:
    //   return siteAdapter.updateOne(
    //     { id: action.payload.id, changes: { value: action.payload.newValue } },
    //     state
    //   );
    // case siteActions.DELETE_SITE:
    // return siteAdapter.removeOne(action.payload.id, state);



    default:
      return state;
  }
}

export const getFetchRunning = (state: State) => state.fetchRunning;
export const getSiteStatus = (state: State) => state.addSiteStatus;

